import { render, staticRenderFns } from "./ToolbarSocial.vue?vue&type=template&id=16aebb72&"
import script from "./ToolbarSocial.vue?vue&type=script&lang=js&"
export * from "./ToolbarSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports